import 'intersection-observer';
import { IntersectionOptions, useInView, defaultFallbackInView } from 'react-intersection-observer';

defaultFallbackInView(true);

export type InViewOptions = IntersectionOptions;

export default useInView;
